import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

import { navLinks } from "../lib/site";
import { CloseIcon, MenuIcon } from "./icons";
import { LogoMark, Wordmark } from "./Logo";

export const SiteHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Close the mobile menu whenever the route changes.
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") setIsOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen]);

  return (
    <header
      className={`site-header${isScrolled ? " site-header--scrolled" : ""}`}
    >
      <div className="site-header__inner">
        <Link to="/" className="logo" aria-label="CatalyxLabs — home">
          <LogoMark size={34} />
          <Wordmark />
        </Link>

        <button
          type="button"
          className="site-header__toggle"
          aria-expanded={isOpen}
          aria-controls="primary-navigation"
          aria-label={isOpen ? "Close menu" : "Open menu"}
          onClick={() => setIsOpen((open) => !open)}
        >
          {isOpen ? <CloseIcon /> : <MenuIcon />}
        </button>

        <nav
          id="primary-navigation"
          className={`site-nav${isOpen ? " site-nav--open" : ""}`}
          aria-label="Primary"
        >
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `site-nav__link${isActive ? " site-nav__link--active" : ""}`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn btn--primary site-nav__cta">
            Book a consultation
          </Link>
        </nav>
      </div>
    </header>
  );
};
